import ajax from "../../lib/ajax";
import util from "../../lib/util";
import { Store, Module, ActionContext } from "vuex";
interface SessionState {
  application: any;
  user: any;
  tenant: any;
  billingAccounts: any;
  billingAccountIdChangedCount: number;
}

class SessionStore implements Module<SessionState, any> {
  namespaced = true;
  state = {
    application: null,
    user: null,
    tenant: null,
    billingAccounts: null,
    billingAccountIdChangedCount: 0
  };
  actions = {
    async init(content: ActionContext<SessionState, any>) {
      let rep = await ajax.get("/api/services/app/Session/GetCurrentLoginInformations", {
        headers: {
          "Abp.TenantId": util.abp.multiTenancy.getTenantIdCookie()
        }
      });
      content.state.application = rep.data.result.application;
      content.state.user = rep.data.result.user;
      content.state.tenant = rep.data.result.tenant;
      content.state.billingAccounts = rep.data.result.billingAccounts;
    },
    async setCurrentBillingAccountId(context: ActionContext<SessionState, any>, newValue: number) {
      await ajax.post("/api/services/app/Configuration/ChangeCurrentBillingAccountId", { id: newValue }).then(response => {
        window.abp.custom.currentBillingAccountId = newValue;
        context.state.billingAccountIdChangedCount++;
      });
    },
    async setCurrentBillingAccount(context: ActionContext<SessionState, any>, account: any) {
      window.abp.custom.currentBillingAccount.id = account.id;
      window.abp.custom.currentBillingAccount.name = account.name;
      window.abp.custom.currentBillingAccount.currentPlan = account.currentPlan;
      window.abp.custom.currentBillingAccount.currentPlanEndDate = account.currentPlanEndDate;
      window.abp.custom.currentBillingAccount.currentPlanPrice = account.currentPlanPrice;
      window.abp.custom.currentBillingAccount.currentPlanStartDate = account.currentPlanStartDate;
      window.abp.custom.currentBillingAccount.cancelAt = account.cancelAt;
      window.abp.custom.currentBillingAccount.canceledAt = account.canceledAt;
      window.abp.custom.currentBillingAccount.logoUrl = account.logoUrl;
      window.abp.custom.currentBillingAccount.status = account.status;
    }
  };
}
const session = new SessionStore();
export default session;
